(() => {
  const dialog=document.getElementById('DropSignup');
  if(!dialog)return;
  const frame=dialog.querySelector('iframe'),template=document.getElementById('DropSignupDocument');
  let opener;
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-signup-open]');
    if(!trigger)return;
    event.preventDefault();opener=trigger;
    frame.srcdoc=template.innerHTML;
    dialog.showModal();document.documentElement.classList.add('signup-is-open');
    dialog.querySelector('[data-signup-close]').focus();
  });
  dialog.querySelector('[data-signup-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const bounds=dialog.getBoundingClientRect();
    if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();
  });
  dialog.addEventListener('close',()=>{frame.removeAttribute('srcdoc');document.documentElement.classList.remove('signup-is-open');opener?.focus();});
  window.addEventListener('message',event=>{if(event.source===frame.contentWindow&&event.data?.type==='2f2w-signup-close')dialog.close();});
})();
